import React, { useEffect } from 'react'
import { BCEntityBase } from '../models/shared/BCEntityBase';
import { azureGetCompanies } from '../utils/api';
import { useAuth } from 'reactfire';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

interface Props {
    companyId: string
    onChange: (companyId: string) => void
}

export default function AzureCompanyPicker({ companyId, onChange }: Props) {
    const [candidates, setCandidates] = React.useState<BCEntityBase[]>([]);
    const [processing, setProcessing] = React.useState(false);
    const { currentUser } = useAuth();

    useEffect(() => {
        const fetchCompanies = async () => {
            setProcessing(true);

            try {
                const token = await currentUser?.getIdToken();
                const candidates = await azureGetCompanies(token);
                setCandidates(candidates);
            } catch (error) {
                console.error('Failed to fetch Azure companies:', error);
                toast.error('Failed to fetch Azure companies. Please try again later.');
            }
            setProcessing(false);
        }

        fetchCompanies();
    }, [currentUser])


    return (
        <div>
            <div>
                <label>Select BC Company</label>
                {processing && <Spinner animation="border" size="sm" className='ms-2' />}
            </div>
            <select className='form-select' value={companyId || ''} onChange={(e) => onChange?.(e.target.value)}
                disabled={processing || candidates.length === 0}
            >
                <option value=''>Select a company</option>
                {candidates.map(company => (
                    <option key={company.id} value={company.id}>{company.name}</option>
                ))}
            </select>

        </div>
    )
}
